import { render, staticRenderFns } from "./SFIssuesDetailsPopUp.vue?vue&type=template&id=e217ffd2&lang=html"
import script from "./SFIssuesDetailsPopUp.vue?vue&type=script&lang=js"
export * from "./SFIssuesDetailsPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports